import React, { Fragment } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "../../container/home";
import About from "../../container/about";
import Contact from "../../container/contact/contact";
import ScrollToTop from "./ScrollToTop";

export default function Routes() {
  return (
    <Router>
      <Fragment>
        <ScrollToTop />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>
        </Switch>
      </Fragment>
    </Router>
  );
}
